<template>
  <div>
    <div class="dropdown-divider"></div>
    <h6 class="dropdown-header">{{ $t('UI_NAV_CUSTOM_IMPORT') }}</h6>
    <button class="dropdown-item" @click="runScript">
      {{ $t('UI_NAV_RUN_SCRIPT') }}
    </button>
  </div>
</template>

<script>
import { RepositoryFactory } from '../../../../repositories/RepositoryFactory';

const DataImporterRepository = RepositoryFactory.get('dataimporter');

export default {
  name: 'DataImporterRunScript',
  methods: {
      async runScript() {
	      await DataImporterRepository.run().then((response) => {
		      this.$snotify.info(this.$t('UI_NAV_SCRIPT_EXECUTED'))
	      }).catch(error => {});
      },
  },
};
</script>

<style scoped>

</style>
